import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import photo from "../assets/iconOnly.png";
import Nav from "../components/Nav";
import SiteMap from "../components/SiteMap";

export default function AboutUs() {

    const scroll = useRef(null)
    const h = window.innerHeight 
    const w = window.innerWidth

    const { scrollY } = useScroll({
        container: scroll
    })

    const imageY = useTransform(scrollY, [0, h* 3], [-300, 100], {
        clamp: false
    })

    
    const input = [0, h -300, h, (h*2) - 300, h*2, (h*3) -300, h*3]

    const x = useTransform(scrollY, input, [0, 0, -w, -w,-w, -w, -w], {
        clamp: false
    }) 
    const xView = useTransform(scrollY, input, [w, 0, -w, -w,-w, -w, -w], {
        clamp: false
    }) 

    const x1 = useTransform(scrollY, input, [w, w, 0, 0,-w, -w, -w]) 
    const xViewB = useTransform(scrollY, input, [w, w, w, 0,-w, -w, -w]) 

    const x2 = useTransform(scrollY,  input,  [w, w, w, w, 0, 0, -w])
    const xViewC = useTransform(scrollY, input, [w, w, w, w, w, 0, -w]) 

    return (
        <>
            <motion.div ref={scroll} id="about-page">
                <Nav scrollY={scrollY} noInverse />
               <motion.div
                    initial={{ y: 300, opacity: 1 }}
                    animate={{ y: 0, opacity: 0.1 }}
                    style={{ position: 'fixed', pointerEvents: 'none', top: 0, left: 0, width: "100vw", height: "100vh", zIndex: 0 }}
                >
                    <motion.img
                        alt="by AltumCode on Unsplash" 
                        src={photo}
                        className="icon-display" 
                        style={{ y: imageY, opacity: 1, zIndex: 1,
                            "-webkit-filter": `brightness(0) invert(1)`,
                        filter: `brightness(0) invert(1)`
                        }} 
                    />
                </motion.div>
                <div style={{ zIndex: 20 }}>

                    <div className="content-wrapper" /> 

                    <motion.div style={{ x: x, position: "fixed", top: 0, pointerEvents: 'none'  }} className="content-wrapper">
                        <motion.h2 initial={{ y: 100, opacity: 0 }} animate={{ y: 0, opacity: 1}} className="title">Our Story</motion.h2>
                        <motion.div transition={{ delay: 0.2 }} initial={{ y: 100, opacity: 0 }} animate={{ y: 0, opacity: 1}} className="about-paragraph">
                            <p>P&S Tech Solutions is a leading software company specializing in providing innovative solutions for businesses. With a strong focus on quality and customer satisfaction, we have been serving clients in various industries for over a decade. Our journey began with a vision to leverage technology to drive business growth and efficiency. Today, we are proud to have a dedicated team of skilled professionals who are passionate about creating impactful software solutions.</p>
                        </motion.div>
                    </motion.div>

                    <motion.div 
                        style={{
                            width: "100vw",
                            height: "90vh",
                            backgroundColor: "var(--primary)",
                            position: "fixed",
                            top: "10vh",
                            right: 0,
                            x: xView,
                            pointerEvents: "none"
                        }}
                    />
                    
                    <div className="content-wrapper" />
                    <motion.div style={{ x: x1, position: "fixed", top: 0, pointerEvents: 'none' }} className="content-wrapper">
                        <motion.h2  initial={{ opacity: 0 }} whileInView={{ opacity: 1}} transition={{ duration: 0.4 }} className="title">Our Services</motion.h2>
                        <motion.div  initial={{ opacity: 0 }} whileInView={{ opacity: 1}} transition={{ duration: 0.4 }} className="about-paragraph">
                            <p>+ Custom Software Development</p>
                            <p>+ Web Application Development</p>
                            <p>+ Mobile App Development</p>
                            <p>+ IT Consulting Services</p>
                            <p>+ Software Integration and Maintenance</p>
                            <p>+ Data Analytics and Business Intelligence</p>
                            <p>+ UI/UX Design</p>
                            <p>+ Logo Designs</p>
                            <p>+ Ad/Promo Designs</p>
                            <p>+ Social Media Marketing & Google Ads Marketing</p>
                        </motion.div> 
                    </motion.div>

                    <motion.div 
                        style={{
                            width: "100vw",
                            height: "90vh",
                            backgroundColor: "var(--primary)",
                            position: "fixed",
                            top: "10vh",
                            right: 0,
                            x: xViewB,
                            pointerEvents: "none"
                        }}
                    />
                    
                    <div className="content-wrapper" />
                    <motion.div style={{ x: x2, position: "fixed", top: 0, pointerEvents: 'none' }} className="content-wrapper"> 
                        <motion.h2  initial={{ opacity: 0 }} whileInView={{ opacity: 1}} transition={{ duration: 0.4 }}  className="title">Our Mission</motion.h2>
                        <motion.div  initial={{ opacity: 0 }} whileInView={{ opacity: 1}} transition={{ duration: 0.4 }}   className="about-paragraph">
                            <p>At P&S Tech Solutions, our mission is to empower businesses by delivering innovative software solutions that drive growth, enhance efficiency, and foster success. We are committed to providing reliable, scalable, and customized services tailored to our clients' specific needs. With a customer-centric approach and a focus on long-term partnerships, we strive to exceed expectations and deliver exceptional value to our clients.</p>
                        </motion.div>
                    </motion.div>

                    <motion.div 
                        style={{
                            width: "100vw",
                            height: "90vh",
                            backgroundColor: "var(--primary)",
                            position: "fixed",
                            top: "10vh",
                            right: 0,
                            x: xViewC,
                            pointerEvents: "none"
                        }}
                    />
        
                    <div style={{ zIndex: 5000 }}>
                        <div style={{ height: 300 }} />
                        <SiteMap scroll={0} />
                    </div>
                    
                
                </div>
            </motion.div>

        </>
    )
}